import React, { useState } from 'react';
import { Logo1, Logo2, Logo3, Logo1Compact, Logo2Compact, Logo3Compact } from '../components/Logos';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export const LogoShowcase = () => {
  const [selectedLogo, setSelectedLogo] = useState(1);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#0A1F44] to-[#153356]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-5xl font-bold mb-4">Trademark Liberty</h1>
            <h2 className="text-3xl mb-6">Logo Design Options</h2>
            <p className="text-xl text-gray-300">Choose your preferred logo design</p>
          </div>
        </div>
      </section>

      {/* Logo Options */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            
            {/* Logo Option 1 */}
            <div 
              className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all cursor-pointer border-4 ${
                selectedLogo === 1 ? 'border-[#D4AF37]' : 'border-transparent'
              }`}
              onClick={() => setSelectedLogo(1)}
            >
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-[#0A1F44] mb-2">Option 1</h3>
                <p className="text-gray-600">Classic Shield Design</p>
              </div>
              <div className="flex justify-center mb-8">
                <Logo1 />
              </div>
              <div className="space-y-3 text-sm text-gray-600">
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Traditional legal shield symbolizes protection</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>TM monogram represents trademark focus</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Split-level typography for brand hierarchy</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Professional and authoritative</span>
                </div>
              </div>
            </div>

            {/* Logo Option 2 */}
            <div 
              className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all cursor-pointer border-4 ${
                selectedLogo === 2 ? 'border-[#D4AF37]' : 'border-transparent'
              }`}
              onClick={() => setSelectedLogo(2)}
            >
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-[#0A1F44] mb-2">Option 2</h3>
                <p className="text-gray-600">Scales of Justice</p>
              </div>
              <div className="flex justify-center mb-8">
                <Logo2 />
              </div>
              <div className="space-y-3 text-sm text-gray-600">
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Balance scales represent fairness & law</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Modern minimalist design approach</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Clean lines and sophisticated look</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Universally recognized legal symbol</span>
                </div>
              </div>
            </div>

            {/* Logo Option 3 */}
            <div 
              className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all cursor-pointer border-4 ${
                selectedLogo === 3 ? 'border-[#D4AF37]' : 'border-transparent'
              }`}
              onClick={() => setSelectedLogo(3)}
            >
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-[#0A1F44] mb-2">Option 3</h3>
                <p className="text-gray-600">Circular Badge</p>
              </div>
              <div className="flex justify-center mb-8">
                <Logo3 />
              </div>
              <div className="space-y-3 text-sm text-gray-600">
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Circular badge for official seal feeling</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>T&L monogram in elegant gold</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Modern professional aesthetic</span>
                </div>
                <div className="flex items-start space-x-2">
                  <span className="text-[#D4AF37] font-bold">✓</span>
                  <span>Works well at any size</span>
                </div>
              </div>
            </div>

          </div>

          {/* Selected Logo Preview */}
          <div className="bg-white rounded-2xl p-12 shadow-xl">
            <h3 className="text-3xl font-bold text-[#0A1F44] text-center mb-12">
              Selected Logo Preview
            </h3>
            
            {/* Light Background Preview */}
            <div className="mb-12">
              <p className="text-sm text-gray-600 mb-4 text-center">On Light Background (Website Header)</p>
              <div className="bg-white border-2 border-gray-200 rounded-xl p-8 flex justify-center">
                {selectedLogo === 1 && <Logo1 />}
                {selectedLogo === 2 && <Logo2 />}
                {selectedLogo === 3 && <Logo3 />}
              </div>
            </div>

            {/* Dark Background Preview */}
            <div className="mb-12">
              <p className="text-sm text-gray-600 mb-4 text-center">On Dark Background (Navbar)</p>
              <div className="bg-[#0A1F44] rounded-xl p-8 flex justify-center">
                {selectedLogo === 1 && <Logo1Compact />}
                {selectedLogo === 2 && <Logo2Compact />}
                {selectedLogo === 3 && <Logo3Compact />}
              </div>
            </div>

            {/* Small Size Preview */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <p className="text-sm text-gray-600 mb-4 text-center">Favicon/Small Size</p>
                <div className="bg-gray-100 rounded-xl p-4 flex justify-center">
                  <div className="transform scale-50">
                    {selectedLogo === 1 && <Logo1 />}
                    {selectedLogo === 2 && <Logo2 />}
                    {selectedLogo === 3 && <Logo3 />}
                  </div>
                </div>
              </div>
              
              <div>
                <p className="text-sm text-gray-600 mb-4 text-center">Medium Size</p>
                <div className="bg-gray-100 rounded-xl p-4 flex justify-center">
                  <div className="transform scale-75">
                    {selectedLogo === 1 && <Logo1 />}
                    {selectedLogo === 2 && <Logo2 />}
                    {selectedLogo === 3 && <Logo3 />}
                  </div>
                </div>
              </div>
              
              <div>
                <p className="text-sm text-gray-600 mb-4 text-center">Large Size</p>
                <div className="bg-gray-100 rounded-xl p-4 flex justify-center">
                  <div className="transform scale-100">
                    {selectedLogo === 1 && <Logo1 />}
                    {selectedLogo === 2 && <Logo2 />}
                    {selectedLogo === 3 && <Logo3 />}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Implementation Note */}
          <div className="mt-12 bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-xl">
            <h4 className="text-lg font-bold text-blue-900 mb-2">Implementation Ready</h4>
            <p className="text-blue-800">
              All logos are built with SVG and React components. They're fully scalable, 
              resolution-independent, and ready to be integrated into your website. Simply import 
              the logo component of your choice!
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};
